import React,{useState,useEffect} from "react";
import { SERVERURL } from "../../../ServerUrl";
import PartnerEditPage from './PartnerEditPage';

import Swal from "sweetalert2";
import axios from "axios";

const PodcastsTable = (props) => {
  const [filtered2, setFiltered2] = useState([]);
  const [selectedRow2, setSelectedRow2] = useState(null);
 
  const updateFilteredData = () => {
    if (props.driverData) { 
      setFiltered2(props.driverData);
    }
  };

  const deleteClicked = async (index, id, row) => {
    console.log(index, id); //mongoid, array index
    console.log(row); //that particular object
  
    Swal.fire({
      title: '',
      text: 'Are you sure to Delete ' + row.title + '?',
      icon: 'warning', // Change 'alert' to 'info' for the icon
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, Delete it!'
    }).then(async (result) => { // Add 'async' before (result)
      if (result.isConfirmed) {
        try {
  
          const token = localStorage.getItem('token'); 
          
          const headers = {
            'Authorization': `Bearer ${token}`, // Corrected header format
          };
          const response = await axios.post(`${SERVERURL}/api/v1/deletePodcast`, { id: index },{
            headers: headers, // Include the headers object in the request configuration
          });
          console.log("kuch ni aya" + response.data);
  
          if (response.data.message === "Podcast Deleted Successfully!" || response.data.success === true) {
            // Update the state or perform any action on successful verification
            Swal.fire(
              '',
              'Deleted Successfully!',
              'success'
            );

            let zz = filtered2.filter((item) => item.title !== row.title);
            setFiltered2(zz);
          }
          else
          {
            if(response.data.success === false)
            {
              Swal.fire(
                '',
                response.data.message,
                'error'
              );
            }

          }
        } catch (error) {
          console.log("response 4", error.response)
          if (error.response.data.message) {
            console.error(error.response);
            Swal.fire({
              title: "",
              text: error.response.data.message,
              icon: 'error', // Change 'Error' to 'error' for the icon
              showCancelButton: true,
              cancelButtonColor: '#d33',
            })
          }
        }
      }
    });
  
  };



  useEffect(() => {
    updateFilteredData();
  }, [props.driverData]); 
  
  return (
    <div className="admin-table">
      <table className="specialWidthTable" >
        <thead>
          <tr>
            <th>Title</th>
            <th>Link</th>
            <th>Thumbnail</th>

            <th>Uploaded At:</th>

             <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {filtered2.map((item, index) => (
            <tr key={index}>
            <td className="admin-table-strong">{item.title}</td>
            <td className="admin-table-strong">{item.link}</td>
            <td className="admin-table-strong"><div style={{width:"170px",height:"50px"}}>
              <img src={SERVERURL+"/uploads/"+item.thumbnail}
               style={{width:"100%",height:"100%",objectFit:"contain"}} />
            </div></td>            
            <td className="admin-table-strong">{item.createdAt}</td>

           <td className="admin-actions-cell" style={{alignItems:"center",height:"100%",paddingTop:"41px"}}>
                
                <button className="admin-action admin-action-delete" style={{alignSelf:"center",marginTop:"5px"}} onClick={() => deleteClicked(item._id, index, item)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
};

export default PodcastsTable;